import companies from 'modules/core/store/collections/companies'
import type Company from 'modules/core/store/models/Company'

import type Job from 'modules/ats/store/models/Job'
import { WorkplaceType } from 'modules/ats/types/job'

const mapPostingDetailsEmploymentType = (job: Job) => {
  switch (job.attributes.contract_type) {
    case 'indefinite':
      return 'permanent'
    case 'temporary':
      return 'temporary'
    case 'fixed_discontinued':
      return 'fixed_term'
    case 'apprenticeship':
    case 'jovem_aprendiz':
    case 'apprentissage':
    case 'training':
      return 'traineeship'
    case 'intern':
      return 'internship'
    case 'freelance':
    case 'vendor_contractor':
      return 'freelance'
    default:
      return 'permanent'
  }
}

const mapPostingDetailsSalaryIndication = (job: Job) => {
  let from = Number(job.attributes.salary_from_amount_in_cents)
  let to: number | null = Number(job.attributes.salary_to_amount_in_cents)

  const currentPeriod = job.attributes.salary_period
  const period = currentPeriod === 'annual' || currentPeriod === 'daily' ? 'yearly' : currentPeriod

  if (currentPeriod === 'daily') {
    from *= 365
    to *= 365
  }

  if (to < 1) to = null

  return { period, range: { from, to, currency: 'EUR' } }
}

const mapPostingDetailsOrganization = (company: Company) => {
  return {
    name: company.attributes.name,
    companyLogo: company.attributes.logo || '',
  }
}

const mapPostingDetailsWorkingLocation = (job: Job) => {
  return {
    addressLine1: job.location?.attributes.address_line_1 || '',
    addressLine2: job.location?.attributes.address_line_1 || '',
    city: job.location?.attributes.city || '',
    country: job.location?.attributes.country || '',
    postcode: job.location?.attributes.postal_code || '',
    allowsRemoteWork:
      job.attributes.workplace_type === WorkplaceType.Remote ||
      job.attributes.workplace_type === WorkplaceType.Hybrid,
  }
}

const mapWorkingHours = (job: Job) => {
  switch (job.attributes.schedule_type) {
    case 'full_time':
      return 40
    default:
      return 0
  }
}

const mapPostingDetailsWeeklyWorkingHours = (job: Job) => {
  return {
    from: mapWorkingHours(job),
    to: mapWorkingHours(job),
  }
}

const mapPostingDetails = (job: Job, buildUrl: (path: string) => string) => {
  return {
    title: job.attributes.title,
    description: job.attributes.description || '',
    yearsOfExperience: 0,
    employmentType: mapPostingDetailsEmploymentType(job),
    weeklyWorkingHours: mapPostingDetailsWeeklyWorkingHours(job),
    salaryIndication: mapPostingDetailsSalaryIndication(job),
    organization: mapPostingDetailsOrganization(companies.current),
    workingLocation: mapPostingDetailsWorkingLocation(job),
    jobPageUrl: buildUrl(`/job_posting/${job.id}`),
    applicationUrl: buildUrl(`/apply/${job.id}`),
  }
}

export const getMappedJobToHapiElementsCampaignForm = (
  job: Job,
  buildUrl: (path: string) => string
) => {
  return {
    postingDetails: mapPostingDetails(job, buildUrl),
    orderedProductsSpecs: {},
    orderedProducts: [],
  }
}
